<template>
  <div>
    <TransitionWrapper name="slideVertical">
      <Select
        v-if="selectedCountry"
        v-model="user.state"
        data-test-id="StatePicker__Select"
        isFullWidth
        :label="selectedCountry.label"
        large
        :name="inputField.state.name"
        :options="stateOptions"
        rules="required"
        @blur="sendInputEnteredEvent(inputField.state)"
      />
    </TransitionWrapper>
  </div>
</template>

<script>
import {
  Select,
  TransitionWrapper,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import SignupConstants from 'client/util/Constants/SignupConstants';

const { countryStates } = SignupConstants;

export default {
  name: 'StatePicker',

  components: {
    Select,
    TransitionWrapper,
  },

  data() {
    return {
      countryStates,
      inputField: {
        state: {
          label: 'State / Province Label', // This is a generic label that is specifically used for the segment event. The actual label that is displayed on the front end is determined by the selectedCountry computed property.
          name: 'state',
        },
      },
    };
  },

  computed: {
    ...mapState(['user']),

    selectedCountry() {
      switch (this.user.country) {
        case 'United States':
          return this.countryStates.us;

        case 'Canada':
          return this.countryStates.ca;

        case 'Australia':
          return this.countryStates.au;

        default:
          return null;
      }
    },

    stateOptions() {
      const stateOptions = [];
      if (this.selectedCountry) {
        for (let i = 0; i < this.selectedCountry.stateList.length; i += 1) {
          const state = {};
          state.name = this.selectedCountry.stateList[i].name;
          state.value = this.selectedCountry.stateList[i].name;
          stateOptions.push(state);
        }
        return stateOptions.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }

      return stateOptions;
    },
  },

  watch: {
    'user.country': function () {
      this.user.state = '';
    },
  },

  methods: {
    ...mapActions([
      'sendInputEnteredEvent',
    ]),
  },
};
</script>
